import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { map, Observable, shareReplay } from 'rxjs'
import { EventEmitter } from '@angular/core'
import { EquipmentModel, EquipmentParams, EquipmentRequest } from './equipment'
import { TelefonePipe } from 'src/app/shared/pipes/telefone.pipe'
import { environment } from 'src/environments/environment'
import { ServiceOrder } from 'src/app/features/service-order/service-order'

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {
  constructor(
    private _httpClient: HttpClient,
    private _phonePipe: TelefonePipe
  ) {}

  private url = environment.apiUrl + '/equipamentos'
  private equipmentList$: Observable<EquipmentModel[]> | null = null
  public total_records = 0
  public equipmentToEdit: EquipmentModel = {} as EquipmentModel
  public equipmentToDelete: string = ''
  public equipmentListEventEmitter: EventEmitter<EquipmentModel[]> =
    new EventEmitter()

  private formatEquipment(list: EquipmentModel[]): EquipmentModel[] {
    const newListEquipment: EquipmentModel[] = []

    list.map((element) => {
      const newEquipment: EquipmentModel = {
        ...element,
      }
      newListEquipment.push(newEquipment)
    })

    return newListEquipment
  }

  public getAllEquipments(objParams?:EquipmentParams, includeDeleted: boolean = false) {

    let request:any
    if(objParams) {

      let params = new HttpParams()
      .set('page', objParams.page)
      .set('page_size', objParams.page_size)
      .set('term', objParams.term)
      .set('tags', objParams.filter?.join(","));
      
      // Adicionar parâmetro para incluir deletados se solicitado
      if (includeDeleted) {
        params = params.set('include_deleted', 'true')
      }

      request = this._httpClient.get<EquipmentRequest>(this.url, {params})

    }else{

      let params: any = {
        page: 1,
        page_size: 10
      }
      
      // Adicionar parâmetro para incluir deletados se solicitado
      if (includeDeleted) {
        params.include_deleted = 'true'
      }

      request = this._httpClient.get<EquipmentRequest>(this.url, {params})
    }
    
    request.subscribe((res:EquipmentRequest) => {
      this.total_records = res.total_records }
    )

    this.equipmentList$ = request.pipe(
      map((data:EquipmentRequest) => this.formatEquipment(data.results)),
      shareReplay(1)
    )
    

    this.equipmentList$!.subscribe((data) => {
      this.equipmentListEventEmitter.emit(data)
    })
  }

  public clearEquipmentCache() {
    this.equipmentList$ = null
    this.getAllEquipments()
  }

  saveNewEquipment(equipment: Omit<EquipmentModel, 'status' | 'nome_loja'>) {
    return this._httpClient.post<EquipmentModel>(this.url, equipment)
  }

  getEquipmentTypes():Observable<any>  {
    return this._httpClient.get(this.url+'/types')
  }

  editEquipment(equipment: EquipmentModel, imei:number) {
    return this._httpClient.put<EquipmentModel>(this.url+'/'+imei, equipment)
  }

  deleteEquipment() {
    return this._httpClient.delete<any>(
      this.url+'/'+this.equipmentToDelete
    )
  }

  public getFullListEquipment(freeOnly: boolean = false, includeDeleted: boolean = false):  Observable<any> {
    let params = new HttpParams()
    if (freeOnly) {
      params = params.set('free_only', 'true')
    }
    if (includeDeleted) {
      params = params.set('include_deleted', 'true')
    }
    return this._httpClient
    .get<EquipmentRequest>(this.url+'/lista', { params })
  
  }

  public getInfoOsEquipmentById(id: string): Observable<ServiceOrder[]> {
    return this._httpClient.get<ServiceOrder[]>(`${this.url}/orders-service/${id}`);
  };

  public handleStatusDevice(disabled: boolean, idImei: string): Observable<void>{
    return this._httpClient
    .put<void>(`${this.url}/status/${idImei}?disabled=${disabled}`, {})
  }

  saveEquipmentWithChip(equipment: any, chip: any): Observable<any> {
    return this._httpClient.post<any>(`${this.url}/with-chip`, {
      equipment,
      chip
    })
  }

  recoverEquipment(imei: string): Observable<any> {
    return this._httpClient.put<any>(`${this.url}/recover/${imei}`, {})
  }

  permanentDeleteEquipment(imei: string): Observable<any> {
    return this._httpClient.delete<any>(`${this.url}/permanent/${imei}`)
  }
}
